import { Box, Button, Typography } from "@mui/material";

const HeaderSection = ({
  label,
  disabledClearAll = false,
  onClearAll = () => {},
  onClose,
  showClearAll = true,
}: {
  label: String;
  disabledClearAll?: Boolean;
  onClearAll?: any;
  onClose: any;
  showClearAll?: Boolean;
}) => {
  return (
    <Box
      sx={{
        borderBottom: "1px solid #E2E2E2",
        px: "4%",
        py: "20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
        <img
          src="/assets/img/icons/arrow_left.svg"
          height="24"
          width="24"
          onClick={onClose}
          role="button"
          alt=""
        />
        <Typography
          sx={{
            fontSize: "22px",
            fontWeight: 600,
            lineHeight: "31px",
          }}
        >
          {label}
        </Typography>
      </Box>
      {showClearAll && (
        <Button onClick={onClearAll} disabled={Boolean(disabledClearAll)}>
          Clear All
        </Button>
      )}
    </Box>
  );
};

export default HeaderSection;
